import { Observable, of } from 'rxjs';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
import { OperationState } from 'src/app/components/operation/store/operation.reducer';
import * as fromOperationAction from 'src/app/components/operation/store/operation.actions';
import * as fromOperationSelector from 'src/app/components/operation/store/operation.selectors';

@Component({
  selector: 'app-operation-participants-item',
  templateUrl: './operation-participants-item.component.html',
  styleUrls: ['./operation-participants-item.component.scss'],
})
export class OperationParticipantsItemComponent implements OnInit {
  participant$: Observable<any> = of(null);
  @Output() back = new EventEmitter<string>(false);

  constructor(private operationStore: Store<OperationState>) {}

  ngOnInit(): void {
    this.getParticipant();
  }

  onBack(): void {
    this.back.emit('participants');
  }

  getParticipant(): void {
    this.participant$ = this.operationStore.select(
      fromOperationSelector.participant
    );
  }
}
